import React from 'react'
import Grid from '@material-ui/core/Grid'
import Info from '@material-ui/icons/InfoOutlined'
import KeyboardBackspace from '@material-ui/icons/KeyboardBackspace'
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';



import { ProductParameterValue } from '../../../../product/model'

export interface ProductParameterExpansionDesignLaterProps {
    back: () => void
    description?: boolean
    value: ProductParameterValue
    manual: string
    valueSelect: (value: ProductParameterValue) => void
    valueSelected: ProductParameterValue[]
    twoSided: boolean
}

export const ProductParameterExpansionDesignLater = (props: ProductParameterExpansionDesignLaterProps) => {
    return <Grid container direction='column' >
        <Grid item container justify='space-between' wrap='nowrap'>
            <Grid item style={{ cursor: 'pointer' }}>
                <Grid container alignItems='center' className='ProductParameterExpansionDesignOwn-recommendedParameters'>
                    <Info />
                    <a href={props.manual} target='_blank' >Recommended parameters</a>
                </Grid>
            </Grid>
            <Grid item onClick={() => props.back()} style={{ cursor: 'pointer' }}>
                <Grid container alignItems='center'>
                    <KeyboardBackspace />
                    <div>Changed your mind?</div>
                </Grid>
            </Grid>
        </Grid>
        <Grid container className='ProductParameterExpansionDesignLater-container'>
            <div>
                <p>The 'Later' option of the Product Design lets you postpone choosing or delivering the design.</p>
                <p>After placing the order you have 72 hours to send the designs via e-mail at <a href='mailto:k.surmacz@flagi.pl'>k.surmacz@flagi.pl</a>.</p>
                <p>Please find below the instruction with the design recommended parameters.</p>
                <p>We will send an appropriate notification to your e-mail address with the hereby procedure.</p>
            </div>
            <Grid container alignContent='center' direction='column'>
                <div>Recommended parameters</div>
                <a href={props.manual} target='_blank'  className='ProductParameterExpansionDesignLater-container__link'>
                    <PictureAsPdfIcon className='ProductParameterExpansionDesignLater-container__pdf' />
                </a>
            </Grid>
        </Grid>
    </Grid>
}